import { render, staticRenderFns } from "./TemplateContentSelection.vue?vue&type=template&id=7c2c6680&scoped=true&"
import script from "./TemplateContentSelection.vue?vue&type=script&lang=ts&"
export * from "./TemplateContentSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2c6680",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
